/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-template */
/* eslint-disable no-console */

export const trace = (message?: any, ...optionalParams: any[]) => console.trace('Butterfly.Test.Trace: ', message, ...optionalParams);
export const debug = (message?: any, ...optionalParams: any[]) => console.debug('Butterfly.Test.Debug: ', message, ...optionalParams);
export const info = (message?: any, ...optionalParams: any[]) => console.info('Butterfly.Test.Info: ', message, ...optionalParams);
export const log = (message?: any, ...optionalParams: any[]) => console.log('Butterfly.Test.Log: ', message, ...optionalParams);
export const warn = (message?: any, ...optionalParams: any[]) => console.warn('Butterfly.Test.Warn: ', message, ...optionalParams);
export const error = (message?: any, ...optionalParams: any[]) => console.error('Butterfly.Test.Error: ', message, ...optionalParams);
